import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { useSelector } from 'react-redux';

import { US } from '../../../../constants/country-codes';
import { useSupportChat } from '../../../../global/support-chat/use-support-chat';
import Global from '../../../../store/global-selectors';
import { messages } from '../messages';

/**
 * @typedef {object} SupportChatItem
 * @property {string} url
 * @property {React.ReactNode} description
 * @property {(e: Event) => void} onClick
 * @property {string} testId
 */

/**
 * @param {string} source - OpenSierraSource value for analytics attribution.
 * @returns {SupportChatItem|null}
 */
const useSupportChatItem = (source) => {
  const supportCountry = useSelector(Global.selectSellerHomeCountry) || US;
  const { isEnabled, openSupportChat } = useSupportChat();

  return useMemo(() => {
    if (!isEnabled) {
      return null;
    }

    const getChatMessage = (country) => {
      const countryChats = {
        FR: <FormattedMessage {...messages.frenchSupportChat} />,
        default: <FormattedMessage {...messages.defaultSupportChat} />,
      };
      return countryChats[country] || countryChats.default;
    };

    return {
      // HACK on URL to force anchor styling on this dropdown item
      url: '/enterprise-chat',
      description: getChatMessage(supportCountry),
      onClick: (e) => {
        e.preventDefault();
        openSupportChat(source);
      },
      testId: 'support-chat-item',
    };
  }, [supportCountry, isEnabled, openSupportChat, source]);
};

export default useSupportChatItem;
